import { useEffect, type Dispatch, type SetStateAction } from "react";
import type { DividerPolicy } from "@CommonTypes/backend/PspRules";
import type { PogNonCircular } from "@CommonTypes/merchflow/pog/pog";
import { fallBackFromUnusableBase } from "./dividerRulesModel";

/**
 * Once the base planogram has loaded, a base rule on divider data that can't
 * be used falls back to no dividers. It runs when loading ends, not on policy
 * edits: the policy is not a dependency.
 */
export const useDividerFallbackOnLoad = (
  basePog: PogNonCircular | null,
  isLoading: boolean,
  setPolicy: Dispatch<SetStateAction<DividerPolicy>>,
) => {
  useEffect(() => {
    if (isLoading) return;
    setPolicy((policy) => fallBackFromUnusableBase(policy, basePog));
  }, [basePog, isLoading, setPolicy]);
};
